import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';

import {
  BrowserRouter as Router
} from "react-router-dom";

import { createTheme, ThemeProvider } from '@material-ui/core';

const theme = createTheme({
  typography: {
    fontFamily: "Product Sans",
    fontWeightLight: 400,
    fontWeightMedium: 400,
    fontWeightRegular: 400,
    fontWeightBold: 700,
  },
  palette: {
    primary: {
      main: "#D6AD60",
    },
    tonalOffset: 0.2,
  },
});

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <ThemeProvider theme={theme}><App /></ThemeProvider>
    </Router>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
